import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';

const StyledJobsSection = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 50px 40px; /* Reduced top padding from 100px to 60px */
  text-align: left;

  h2 {
    font-size: var(--fz-heading);
    margin-bottom: 40px;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      margin-bottom: 20px; /* Reduced spacing between job entries */
      font-size: var(--fz-lg);
      display: flex;
      flex-direction: column;

      .job-header {
        display: flex;
        flex-direction: column; /* Stack title and company vertically */
        align-items: flex-start; /* Align to the left */
        margin-bottom: 5px; /* Reduced spacing */

        .job-title {
          font-weight: bold;
          color: var(--green);
          font-size: var(--fz-xl);
        }

        .company {
          color: var(--light-slate);
          font-size: var(--fz-md);
          margin-top: 3px; /* Add spacing between title and company */
        }
      }

      .location {
        font-size: var(--fz-sm);
        color: var(--slate);
        margin-bottom: 3px; /* Reduced spacing */
      }

      .duration {
        font-size: var(--fz-sm);
        color: var(--slate);
        margin-bottom: 5px; /* Reduced spacing */
      }

      .description {
        font-size: var(--fz-md);
        color: var(--light-slate);
        line-height: 1.4; /* Optimized line height */
        margin-bottom: 5px; /* Reduced spacing */

        ul {
          margin: 0;
          padding-left: 20px;

          li {
            margin-bottom: 5px; /* Reduced spacing between list items */
          }
        }
      }
    }
  }
`;

const Jobs = () => {
  const data = useStaticQuery(graphql`
    query {
      jobs: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/content/jobs/" } }
        sort: { fields: [frontmatter___date], order: DESC }
      ) {
        edges {
          node {
            frontmatter {
              title
              company
              location
              range
              description
            }
          }
        }
      }
    }
  `);

  const jobsData = data.jobs.edges;

  return (
    <StyledJobsSection id="jobs">
      <h2 className="numbered-heading">Work Experience</h2>
      <ul>
        {jobsData.map(({ node }, i) => {
          const { title, company, location, range, description } = node.frontmatter;
          return (
            <li key={i}>
              <div className="job-header">
                <span className="job-title">{title}</span>
                <span className="company">{company}</span>
              </div>
              <div className="location">{location}</div>
              <div className="duration">{range}</div>
              {description && (
                <div className="description">
                  <p>{description.split('\n')[0]}</p>
                  <ul>
                    {description
                      .split('\n')
                      .slice(1)
                      .map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                  </ul>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </StyledJobsSection>
  );
};

export default Jobs;
